import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';

export default function Save({ attributes }) {
  const blockProps = useBlockProps.save({
    className: 'community-commitment-section'
  });

  const { mainTitle, linkText, linkUrl, reverseColumns, hideLink } = attributes;

  return (
    <div {...blockProps}>
      <div className="py-4 md:py-16 bg-white">
        <div className="max-w-inner mx-auto px-4">
          <div className={`grid grid-cols-1 lg:grid-cols-12 items-center gap-4 md:gap-16 ${reverseColumns ? 'lg:grid-flow-col-dense' : ''}`}>
            {/* Content Column - Always 8/12 width */}
            <div className={`flex items-center lg:col-span-8 ${reverseColumns ? 'order-2 lg:order-2 lg:col-start-5' : 'order-2 lg:order-1 lg:col-start-1'}`}>
              <div className="w-full">
                <div className="flex flex-col md:flex-row md:items-center items-start justify-between mb-4">
                  <h2 
                    className="~text-2xl/4xl font-bold mb-4 md:mb-0"
                    dangerouslySetInnerHTML={{ __html: mainTitle }}
                  />
                  <img 
                    src="/wp-content/themes/puroclean-tw/assets/img/puro-cares.png" 
                    alt="PuroClean Cares" 
                    width="182" 
                    height="91" 
                    className="flex-shrink-0 md:ml-4 w-[155px] md:w-[182px]"
                    loading="lazy"
                  />
                </div>
                
                <div className="text-lg mb-8 space-y-4">
                  <InnerBlocks.Content />
                </div>
                
                {!hideLink && (
                  <span className="text-lg flex flex-col md:flex-row items-start md:items-center mt-4 gap-0 md:gap-2 font-semibold">
                    <a href={linkUrl || '/community'} className="text-primary flex">
                      <span 
                        className="underline"
                        dangerouslySetInnerHTML={{ __html: linkText || 'Learn More About Our Community Commitment' }}
                      />
                      <img 
                        src="/wp-content/themes/puroclean-tw/assets/img/linking-arrow.svg" 
                        alt="Linking Arrow" 
                        width="20" 
                        className="ml-2" 
                      />
                    </a>
                  </span>
                )}
              </div>
            </div>
            
            {/* Image Column - Always 4/12 width */}
            <div className={`lg:col-span-4 ${reverseColumns ? 'order-1 lg:order-1 lg:col-start-1' : 'order-1 lg:order-2 lg:col-start-9'}`}>
              <figure className="size-large rounded-lg">
                <img 
                  src="/wp-content/themes/puroclean-tw/assets/img/people-teaching.png" 
                  alt="Community Teaching and Support"
                  className="rounded-lg w-full h-auto"
                  loading="lazy"
                />
              </figure>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}



